import React from "react";
import { Box, Grid, TableCell, TableRow, Typography } from "@mui/material";
import img from "../../../Images/pic.png";
import "./About.css";

const About = () => {
  return (
    <Box sx={{ marginTop: 10 }} className="about-container">
      <Grid md={12}> </Grid>

      <Grid container spacing={2}>
        <Grid sm={12} md={5}>
          <img src={img} style={{ width: "80%" }} alt="" srcset="" />
        </Grid>
        <Grid sm={12} md={7} className="about-info-container">
          <h1 className="name-about">
            Ashraful islam
          </h1>
          <p className="about-my-info">
            Hello! I'm Ashraful. I'm a self-thought programmer. having 1+ years
            of experience in the web industry with MERN stack (MongoDB, Express,
            reactjs, redux, and nodejs) and many other technologies. I develop
            responsive and dynamic websites using the MERN stack. If you want a
            website for your company or shop or anything you can contact me. I'm
            a beginner here, but I am not a beginner in web development
          </p>
          <div className="my-info">
            <TableRow>
              <TableCell align="left">Birthday</TableCell>
              <TableCell> 21.02.2004 </TableCell>
            </TableRow>
            <TableRow>
              <TableCell sx={{ width: "55%" }} align="left">
                Age :-
              </TableCell>
              <TableCell sx={{ width: "30%" }}>18</TableCell>
            </TableRow>
            <TableRow>
              <TableCell sx={{ width: "55%" }} align="left">
                Address
              </TableCell>
              <TableCell sx={{ width: "30%" }}> Bangladesh</TableCell>
            </TableRow>
            <TableRow>
              <TableCell sx={{ width: "55%" }} align="left">
                Email
              </TableCell>
              <TableCell sx={{ width: "30%" }}>mail@gmail.com</TableCell>
            </TableRow>
            <TableRow>
              <TableCell sx={{ width: "55%" }} align="left">
                Phone
              </TableCell>
              <TableCell sx={{ width: "30%" }}> 12345 </TableCell>
            </TableRow>
            <TableRow>
              <TableCell sx={{ width: "55%" }} align="left">
                Study
              </TableCell>
              <TableCell sx={{ width: "30%" }}> ABC </TableCell>
            </TableRow>
            <TableRow>
              <TableCell sx={{ width: "55%" }} align="left">
                Freelancer
              </TableCell>
              <TableCell sx={{ width: "30%" }}> Available</TableCell>
            </TableRow>
          </div>
        </Grid>
      </Grid>
    </Box>
  );
};

export default About;